<template>
  <div
    class="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900"
  >
    <div class="text-center">
      <!-- Logo -->
      <img
        :src="require('../../assets/images/logo.jpg')"
        alt="EpicFace"
        class="w-20 h-20 sm:w-24 sm:h-24 mx-auto rounded-2xl shadow-2xl mb-5"
      />

      <h1 class="text-2xl sm:text-3xl font-bold text-white mb-2 px-2">
        {{ t("opener.title") }}
      </h1>
      <p class="text-sm sm:text-base text-white mb-8 sm:mb-10 px-4">
        {{ t("opener.description") }}
      </p>

      <!-- Store Buttons -->
      <div class="flex flex-col gap-3 sm:gap-4 items-center">
        
        <!-- App Store Button -->
        <a
          href="https://apps.apple.com/app/idYOUR_APP_ID"
          target="_blank"
          class="transition-all duration-300 hover:scale-105 hover:opacity-90"
          @click="clickStore('app_store')"
        >
          <img
            :src="require('../../assets/images/app_store.png')"
            :alt="t('opener.downloadOnAppStore')"
            class="h-16 sm:h-28"
          />
        </a>

        <!-- Google Play Button (Coming Soon) -->
        <div class="relative">
          <img
            :src="require('../../assets/images/google_play.png')"
            :alt="t('opener.getItOnGooglePlay')"
            class="h-16 sm:h-28 opacity-50 grayscale cursor-not-allowed"
          />
          <!-- Coming Soon Badge -->
          <div
            class="absolute -right-2 -top-2 bg-purple-600 text-white text-[10px] font-bold px-2 py-0.5 rounded-full shadow-lg"
          >
            {{ t("opener.soon") }}
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, inject } from "vue";
import { useRoute } from "vue-router";

export default {
  setup() {
    const amplitude = inject("amplitude");
    const i18n = inject("i18n");
    const route = useRoute();

    const { t } = i18n;

    const clickStore = (store) => {
      amplitude.track("click-store", {
        store,
        model_id: route.query.modelId || null,
      });
    };

    onMounted(() => {
      amplitude.track("view-opener", {
        model_id: route.query.modelId || null,
      });
    });

    return { clickStore, t };
  },
};
</script>
